<div class="row justify-content-center">
    <div class="col-xl-6 col-lg-8 col-md-10 col-sm-12 mat-elevation-z8">
        <div class="row heading mat-elevation-z8">
            <div class="col-12">
                <h1 class=" text-center  coolfont">Acceptable Usage Policy - Purenet</h1>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <h1>Just make sure you stay within these limits!</h1>
                <h6>This is an acceptable use policy for all of Purenet's services. Failure to comply with this acceptable use policy will result in immediate termination of your account and service without a refund. Note we will always try to reach out to you before we terminate your service. If you have questions please contact us.</h6>
                <br>
                <h6>NOTE – The ISP reserves the right to modify any of their TOS or Policy at any time, effective upon posting. Any modifications to any Policy will be made when the ISP feels it is appropriate and it is the User’s responsibility to ensure their awareness of any such changes.</h6>
                <br>
                <h6>You shall not do any of the following with our services : </h6>
                <ol>
                    <li>Do anything that is illegal or damages Purenet brand or reputation. This includes but is not limited to the following.
                        <ul>
                            <li>Hacking or Cracking attempts to access accounts or systems other than the user’s own accounts or systems or an account or system that the user has been explicitly authorized to access is illegal under national and state law.</li>
                            <li>Child pornography</li>
                            <li>Harassment</li>
                            <li>Fraud</li>
                            <li>Copyright Infringement</li>
                            <li>Fake Social Networking Accounts</li>
                        </ul>
                    </li>
                    <li>Attempt to do anything that will damage our network or disturb it in anyways. Or attempt to gain access to our internal network or systems for any reason. This includes but is not limited to the following.
                        <ul>
                            <li>Denial of service attacks on our networks or are other customers as well as other networks.</li>
                            <li>Any activity that can get our IP space Blacklisted.</li>
                            <li>Anything that will add unusual load to our systems or usage more than the network abuse limit.</li>
                            <li>Gaining access to our systems for any reason.</li>
                            <li>Sharing Internet with your neighbor unofficially and without written consent from Purenet.</li>
                        </ul>
                    </li>
                    <li>Spam – No customer shall send unsolicited commercial email, unsolicited mass mailings, spam, or anything of that sort. 4. Anything that prevents other users from enjoying our service.</li>
                </ol>
            </div>
        </div>
    </div>
</div>